import React from 'react'
import {ROLE_IN_TEAM, ROLE_IN_TEAM_LABEL} from "../../../../../base/constants/users";
import Button from "../../../../../base/components/Button/index";
import {handleWithoutPropagation} from "../../../../../base/helpers/handleWithoutPropagation";
import Popup from "../../../../../base/components/Popups/Popup";
import {ACTION_MEMBER_TYPE, popupSchema} from "../config";

export const TeamsTableStructure = (deleteMember, assignTeamOwner, redirectToUserDetails, isDelete, data) => (location, decorateText) => {
    const firstNameColumn = {
        dataField: "firstName",
        sort: false,
        headerFormatter: () => (<>Member first name</>),
        formatter: (cellContent, teamInfo) => {
            return (
                <section className="d-flex flex-row align-items-center">
                    <span className="tutee-list--list__name" {...decorateText(teamInfo.firstName)} />
                </section>
            )
        }
    };

    const lastNameColumn = {
        dataField: "lastName",
        sort: false,
        headerFormatter: () => (<>Member last name</>),
        formatter: (cellContent, teamInfo) => {
            return (
                <section className="d-flex flex-row align-items-center">
                    <span className="tutee-list--list__name"  {...decorateText(teamInfo.lastName)} />
                </section>
            )
        }
    };

    const roleColumn = {
        dataField: "role",
        sort: false,
        headerFormatter: () => (<>Member role</>),
        formatter: (cellContent) => {
            return <span>{ROLE_IN_TEAM_LABEL[cellContent]}</span>
        }
    };

    const actionColumn = {
        sort: false,
        headerClasses: 'action-cell',
        headerFormatter: () => (<>Manage user</>),
        formatter: (cellContent, userInfo) => {
            const isTeamOwner = userInfo.role === ROLE_IN_TEAM.TEAM_OWNER
            if (data.length > 1) {
                return <div className="d-flex" onClick={handleWithoutPropagation()}>
                    <Popup
                        {...popupSchema[isTeamOwner ? ACTION_MEMBER_TYPE.DELETE_OWNER : ACTION_MEMBER_TYPE.DELETE_MEMBER]}
                        action={() => {
                            if (isTeamOwner) {
                                redirectToUserDetails(userInfo.id)
                            } else {
                                deleteMember(userInfo.id)
                            }
                        }}
                    >
                        <Button
                            color="danger"
                            className="py-1 me-3"
                            outline>
                            Delete
                        </Button>
                    </Popup>
                    {!isTeamOwner && <Popup
                        {...popupSchema[ACTION_MEMBER_TYPE.ASSIGN_TEAM_OWNER]}
                        action={() => {
                            assignTeamOwner(userInfo.id)
                        }}
                    >
                        <Button
                            color="primary"
                            className="py-1">
                            Assign a team owner
                        </Button>
                    </Popup>}
                </div>
            }
        }
    };

    return isDelete
        ? [
            firstNameColumn,
            lastNameColumn,
            roleColumn,
        ]
        : [
            firstNameColumn,
            lastNameColumn,
            roleColumn,
            actionColumn,
        ]

}